import React from "react";
import "./index.less";

// size = em || size = 10 => comps{ width: 420px, height: 340px}
export default class LrLayout extends React.Component {
  static defaultProps: {
    style: {},
  };
  constructor(props) {
    super();
    this.state = {
      size: props.size || 10,
    };
    setTimeout(() => {
      this.setState({});
    }, 2000);
  }

  render() {
    let { size } = this.state;
    let { style } = this.props;
    return (
      <div className={`lr-layout-box`} style={style}>
        {/* <div className="main_spin_box" style={{ fontSize: size }}>
        <div className="spin_nose_box">
          <img className="left" src="/nose_inner.png" alt='' />
          <img className="right" src="/nose_inner.png" alt='' />
        </div>
        <div className="spin_eye_box">
          <img className="left" src="/eye.png" alt='' />
          <img className="right" src="/eye.png" alt='' />
        </div>
      </div> */}
      </div>
    );
  }
}
